import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const EmployeeTypeRoutes = [
  {
    path: '/employee-types',
    name: 'ListEmployeeTypes',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'employee_type:list'
    }
  },
  {
    path: '/employee-type',
    name: 'CreateEmployeeType',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'employee_type:create'
    }
  },
  {
    path: '/employee-type/:id',
    name: 'UpdateEmployeeType',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'employee_type:update'
    }
  },
  {
    path: '/employee-type/view/:id',
    name: 'GetEmployeeType',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'employee_type:get'
    }
  }
]
